module.exports = __webpack_public_path__ + "static/media/top_infographic_mobile.6effa51e.webp";